import { FileChartLineIcon } from 'lucide-react';

import type { PotentialImpactCardProps } from './PotentialImpactCard.types';
import { useTranslation } from 'react-i18next';

export const PotentialImpactCard = ({
  predictedOutcome,
}: PotentialImpactCardProps): React.JSX.Element => {
  const { t } = useTranslation('analysis');

  return (
    <div className="flex flex-col items-center p-6 rounded-lg bg-green-100 dark:bg-positive h-full">
      <div className="mt-4 mb-4 flex size-8 items-center justify-center rounded bg-green-900 dark:bg-positive-foreground">
        <FileChartLineIcon className="size-4 text-green-100 dark:text-positive" />
      </div>
      <p className="text-green-900 dark:text-positive-foreground text-xl font-medium mb-4">
        {t('socialMediaOpportunitiesWidget.potentialImpactCard.potentialImpact')}
      </p>
      <p className="text-lg text-center">
        {predictedOutcome ||
          t('socialMediaOpportunitiesWidget.potentialImpactCard.noPredictedOutcomeAvailable')}
      </p>
    </div>
  );
};
